<script setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  trackBy: {
    type: String,
    default: 'id',
  },

  modelValue: {
    type: [String, Number, Boolean],
    default: undefined,
  },
});
const emit = defineEmits(['update:modelValue']);

const modelValueLocal = useVModel(props, 'modelValue', emit);
</script>

<template>
  <div class="ui-tabs">
    <label
      v-for="(item, index) in items"
      :key="index"
      type="button"
      class="ui-tabs__tab"
      :class="{ 'ui-tabs__tab--active': props.modelValue === item[trackBy] }"
      @click="emit('update:modelValue', item[trackBy])"
    >
      <input
        v-model="modelValueLocal"
        type="radio"
        :value="item[trackBy]"
        hidden
      />

      <CIcon v-if="item.iconName" class="ui-tabs__icon" :name="item.iconName" />

      <span class="ui-tabs__font">
        {{ item.text }}
      </span>
    </label>
  </div>
</template>

<style scoped lang="scss">
.ui-tabs {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid $color-gray-3;
  border-radius: em(8);

  &__font {
    font-size: em(17);
    font-weight: 400;
    line-height: math.div(24, 17);
  }

  &__icon {
    @include box(em(24));

    flex-shrink: 0;
  }

  &__tab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: em(16);
    color: $color-text;
    cursor: pointer;
    background-color: $color-white;
    border-radius: calc(#{em(8)} - 1px);
    transition:
      color $time-3,
      background-color $time-3;

    &--active {
      color: $color-white;
      background-color: $color-main-1;
    }
  }
}
</style>
